import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class India_itme_society extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />

                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                India Itme Society
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>About Us</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>India Itme Society</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <>
                    <section
                        className="about-section section-padding fix bg-cover"
                        style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                    >
                        <div className="container">
                            <div className="about-wrapper style-2">
                                <div className="row"><div className="col-lg-6">
                                    <div className="about-image-items">
                                        <div className="circle-shape">
                                            <img src="assets/img/about/circle.png" alt="shape-img" />
                                        </div>
                                        <div className="counter-shape float-bob-y">
                                            <div className="icon">
                                                <img src="assets/img/about/icon-1.svg" alt="icon-img" />
                                            </div>
                                            <div className="content">
                                                <h3>
                                                    <span className="count">45</span>Years
                                                </h3>
                                                <p>Of Experience</p>
                                            </div>
                                        </div>
                                        <div
                                            className="about-image-1 bg-cover wow fadeInLeft"
                                            data-wow-delay=".3s"
                                            style={{ backgroundImage: 'url("assets/img/about/03.png")' }}
                                        >
                                            <div className="about-image-2 wow fadeInUp" data-wow-delay=".5s">
                                                <img src="assets/img/about/04.jpg" alt="about-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                    <div className="col-lg-6 mt-4 mt-lg-0">
                                        <div className="about-content">
                                            <div className="section-title mb-3 mxw-650">
                                                <div className="subtitle">
                                                    {" "}
                                                    <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                    <span>ABOUT INDIA ITME SOCIETY</span>
                                                    <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                                </div>
                                                {/* <h2 className="title">
                                                    {" "}
                                                    We will offer unmatched business to the{" "}
                                                    <span>Exhibitors</span>{" "}
                                                </h2> */}
                                            </div>
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                India International Textile Machinery Exhibitions Society (India
                                                ITME Society), a 45 year old non profit apex industry body,
                                                established in 1980, to support and serve the Textile
                                                Engineering Industry through Exhibitions &amp; Events.
                                            </p>
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                India ITME Society was conceived with a Vision to play a pivotal
                                                role in strengthening the Indian Textile Engineering Industry by
                                                facilitating exchange of knowledge, technology transfer &amp;
                                                foreign investment in the sector and to be the apex exhibition
                                                body in India for the textile machinery, accessories and
                                                component industry.
                                            </p>
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                The organisation and its team works relentlessly towards its
                                                Mission to aid, stimulate, promote, encourage &amp; support
                                                trade and commerce with a focus on Textile Engineering and
                                                allied industries, through exhibitions and conferences, thus
                                                propagating the cause of Textile Engineering Industry at
                                                National and International levels.
                                            </p>
                                            <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                                With the motto of empowering Textiles through Trade &amp;
                                                Technology, India ITME Society relentlessly spots the right
                                                opportunities that will contribute to the greater good. Over the
                                                years India ITME Society has evolved into the next level,
                                                metamorphosing from an Indian organiser to a global phenomenon
                                                embracing internationalism exploring &amp; connecting emerging
                                                economies to Indian Textile &amp; Engineering Industry.
                                            </p>

                                        </div>
                                    </div>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        The society has left no stones unturned in establishing itself as one
                                        of India's most successful exhibition organizers with its principles
                                        based on trust, consistency &amp; collaboration.
                                    </p>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        <ol>
                                            <li>For more information visit : <a href='https://corporate.india-itme.com/' target='_blank'>https://corporate.india-itme.com/</a></li>
                                            <li>To view the brochure click : <a href='https://corporate.india-itme.com/Corporate-Flipbook/' target='_blank'>India ITME Society Corporate Brochure (india-itme.com)</a></li>
                                            <li>To view the video click : <a href='https://www.youtube.com/watch?v=krrTau-uvCw' target='_blank'>https://www.youtube.com/watch?v=krrTau-uvCw</a></li>
                                        </ol>
                                    </p>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        India ITME Society today organizes exhibitions every year, addressing different requirements of the industry segment under its banner.
                                        <ol>
                                            <li><b>India International Textile Machinery Exhibition (INDIA ITME) </b>- (Flagship event since 1980 completing 45 years)</li>
                                            <li><b>Global Textile Technology & engineering show (GTTES)  </b>- (Focused on SME sector and regional hubs)</li>
                                            <li><b>International Technology, Machinery & Engineering Exhibition (ITME AFRICA & MIDDLE EAST)  </b>- (overseas edition).</li>
                                        </ol>
                                    </p>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        India ITME Society is a trend setter for out of box ideas in serving the industry members, not limited to singular activity of exhibitions but also multiple benefit services for both Domestic & International audience.
                                    </p>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        <b>ITME Trade Services</b> offers
                                        <ol>
                                            <li>Trade Missions : Inbound & Outbound</li>
                                            <li>Trade Enquiry : For Business Opportunities</li>
                                            <li>Trade Information : Knowledge Sessions &amp; Webinars</li>
                                            <li>India Pavilion at International Exhibition</li>
                                            <li>Project Consultancy</li>
                                        </ol>
                                        For more information visit : <a href='www.tradedesk.india-itme.com' target='_blank'>www.tradedesk.india-itme.com</a>
                                    </p>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        India ITME Awards one & only award exclusive for Textile Technology & Engineering Sector.
                                        For more information visit : <a href='www.awards.india-itme.com' target='_blank'>www.awards.india-itme.com</a>
                                    </p>
                                    <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                        Humility of action, integrity of purpose and transparency of conduct
                                        are the key traits driving the Society’s growth and its journey forward.
                                        “India ITME Society – Empowering Textiles through Trade & Technology.”
                                    </p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="offer-section fix section-bg-2 section-padding">
                        <div className="line-shape">
                            <img src="assets/img/team/line-shape.png" alt="shape-img" />
                        </div>
                        <div className="mask-shape">
                            <img src="assets/img/team/mask-shape.png" alt="shape-img" />
                        </div>
                        <div className="container">
                            <div className="section-title title-area  mx-auto mb-15">
                                <div className="subtitle d-flex justify-content-center">
                                    {" "}
                                    <img src="assets/img/icon/arrowLeftWhite.svg" alt="icon" />{" "}
                                    <span className="text-white"> Services</span>
                                    <img src="assets/img/icon/arrowRightWhite.svg" alt="icon" />
                                </div>
                                <h2 className="title text-center text-white"> ITME Trade Services </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="objective_grid">
                                        <div className="single-featuer">
                                            <img className="shape" src="assets/img/shape.svg" alt="shape 1" />
                                            <img
                                                className="shape2"
                                                src="assets/img/shape2.svg"
                                                alt="shape 2"
                                            />
                                            <div className="service-icon">
                                                <img
                                                    src="assets/img/Transforming_India.png"
                                                    alt="Transforming India img"
                                                />
                                            </div>
                                            <h3>Trade Missions</h3>
                                        </div>
                                        <div className="single-featuer">
                                            <img className="shape" src="assets/img/shape.svg" alt="#" />
                                            <img className="shape2" src="assets/img/shape2.svg" alt="#" />
                                            <div className="service-icon">
                                                {/* <i class="lni lni-users"></i> */}
                                                <img
                                                    src="assets/img/Promoting_India.png"
                                                    alt="Promoting India img"
                                                />
                                            </div>
                                            <h3>Trade Enquiry </h3>
                                        </div>
                                        <div className="single-featuer">
                                            <img className="shape" src="assets/img/shape.svg" alt="#" />
                                            <img className="shape2" src="assets/img/shape2.svg" alt="#" />
                                            <div className="service-icon">
                                                <img
                                                    src="assets/img/Market_Development.png"
                                                    alt="Driving New Market Development img"
                                                />
                                            </div>
                                            <h3>Knowledge Sessions & Webinars </h3>
                                        </div>
                                        <div className="single-featuer">
                                            <img className="shape" src="assets/img/shape.svg" alt="#" />
                                            <img className="shape2" src="assets/img/shape2.svg" alt="#" />
                                            <div className="service-icon">
                                                <img
                                                    src="assets/img/Connecting_Manufacturers.png"
                                                    alt="Connecting Manufacturers img"
                                                />
                                            </div>
                                            <h3>International Exhibition Participation</h3>
                                        </div>
                                        <div className="single-featuer">
                                            <img className="shape" src="assets/img/shape.svg" alt="#" />
                                            <img className="shape2" src="assets/img/shape2.svg" alt="#" />
                                            <div className="service-icon">
                                                <img
                                                    src="assets/img/Technology_Exchange.png"
                                                    alt="Technology Exchange img"
                                                />
                                            </div>
                                            <h3>Project Consultancy</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="row mt-30">
                                <div className="col-md-12 text-center">
                                    <div className="about-author">
                                        <div className="about-button wow fadeInUp" data-wow-delay=".5s">
                                            <a
                                                href="http://www.tradedesk.india-itme.com"
                                                target="_blank"
                                                className="theme-btn Explore_More_btn"
                                            >
                                                Explore More
                                                <i className="fa fa-arrow-right-long" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </section>
                    <section className="Opportunities_section">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h3 className="yellow_color ">Empowering Textile Industry</h3>
                                    <p className="text-center">
                                        The society has left no stones unturned in establishing itself as
                                        one of India's most successful <br />
                                        exhibition organizers with its principles based on trust,
                                        consistency &amp; collaboration.
                                    </p>
                                </div>
                            </div>
                            <div className="row mt-50">
                                <div className="col-md-12">
                                    <div className="grid_view_div">
                                        <a href="https://corporate.india-itme.com/" target="_blank">
                                            <img src="assets/img/ITME_img_1.png" />
                                            <h6>India International Textile Machinery Exhibitions Society</h6>
                                            <i className="fa fa-arrow-right-long" />
                                        </a>
                                        <a
                                            href="https://corporate.india-itme.com/Corporate-Flipbook/"
                                            target="_blank"
                                        >
                                            <img src="assets/img/ITME_img_2.png" />
                                            <h6>India ITME Society CorSporate Brochure (india-itme.com)</h6>
                                            <i className="fa fa-arrow-right-long" />
                                        </a>
                                        <a
                                            href="https://www.youtube.com/watch?v=krrTau-uvCw"
                                            target="_blank"
                                        >
                                            <img src="assets/img/ITME_img_3.png" />
                                            <h6>India ITME Society Video</h6>
                                            <i className="fa fa-arrow-right-long" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(India_itme_society));